import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardOlIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.5 11H6.5C6.22386 11 6 11.2239 6 11.5V12.5C6 12.7761 6.22386 13 6.5 13H23.5C23.7761 13 24 12.7761 24 12.5V11.5C24 11.2239 23.7761 11 23.5 11Z"
        fill={color}
      />
      <path
        d="M23.5 20H6.5C6.22386 20 6 20.2239 6 20.5V21.5C6 21.7761 6.22386 22 6.5 22H23.5C23.7761 22 24 21.7761 24 21.5V20.5C24 20.2239 23.7761 20 23.5 20Z"
        fill={color}
      />
      <path
        d="M23.5 2H6.5C6.22386 2 6 2.22386 6 2.5V3.5C6 3.77614 6.22386 4 6.5 4H23.5C23.7761 4 24 3.77614 24 3.5V2.5C24 2.22386 23.7761 2 23.5 2Z"
        fill={color}
      />
      <path
        d="M3.38 0.910004H2L1 2.23L1.58 2.68L2.43 1.56H2.48V4.37H1.35V5.09H4.27V4.37H3.38V0.910004Z"
        fill={color}
      />
      <path
        d="M4.07999 11.13C4.07999 10.4 3.55999 9.87 2.64999 9.87C1.73999 9.87 1.29999 10.36 1.10999 10.94L1.89999 11.24C1.97999 10.92 2.17999 10.65 2.56999 10.65C2.83999 10.65 3.11999 10.85 3.11999 11.17C3.11999 11.52 2.95999 11.8 2.48999 12.2L1.19999 13.3V14.12H4.15999V13.36H2.17999L2.95999 12.75C3.55999 12.28 4.06999 11.84 4.06999 11.12L4.07999 11.13Z"
        fill={color}
      />
      <path
        d="M3.32999 20.9C3.75999 20.82 4.12999 20.48 4.12999 19.94C4.12999 19.27 3.54999 18.83 2.64999 18.83C1.92999 18.83 1.51999 19.12 1.19999 19.53L1.75999 20.06C1.96999 19.74 2.27999 19.56 2.60999 19.56C2.95999 19.56 3.16999 19.79 3.16999 20.09C3.16999 20.35 2.96999 20.56 2.52999 20.56H2.13999V21.31H2.51999C2.96999 21.31 3.24999 21.5 3.24999 21.84C3.24999 22.18 3.00999 22.43 2.59999 22.43C2.14999 22.43 1.89999 22.18 1.71999 21.84L1.04999 22.36C1.31999 22.79 1.74999 23.16 2.59999 23.16C3.54999 23.16 4.18999 22.67 4.18999 21.93C4.18999 21.35 3.81999 20.99 3.31999 20.9H3.32999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardOlIcon.displayName = 'BoardOlIcon';
